import { atom, AtomEffect, DefaultValue } from "recoil";
import { ATOM_SESSION_ID } from "../constants";

/** https://recoiljs.org/docs/guides/atom-effects/#local-storage-persistence */
const sessionStorageEffect: <T>(key: string) => AtomEffect<T> =
  (key: string) =>
  ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key);
    if (savedValue != null) {
      setSelf(JSON.parse(savedValue));
    }

    onSet((newValue) => {
      if (newValue instanceof DefaultValue) {
        sessionStorage.removeItem(key);
      } else {
        sessionStorage.setItem(key, JSON.stringify(newValue));
      }
    });
  };

export const sessionIdAtom = atom<string>({
  key: ATOM_SESSION_ID,
  default: "",
  effects: [sessionStorageEffect<string>(ATOM_SESSION_ID)],
});
